import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function formatApiError(detail) {
  if (detail == null) return "Qualcosa è andato storto. Riprova.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  }
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const PHONE_OFFICE_DISPLAY = "351 4129152";
export const PHONE_OFFICE = "tel:+393514129152";
export const PHONE_FOUNDER_DISPLAY = "327 1757953";
export const PHONE_FOUNDER = "tel:+393271757953";
export const WHATSAPP_URL =
  "https://wa.me/393514129152?text=Salve%2C%20ho%20visto%20il%20sito%20di%20A.C.%20HUB%2C%20vorrei%20richiedere%20una%20consulenza.";
export const EMAIL_DIREZIONE = "direzione@achubimmobiliare.it";
export const EMAIL_ALESSIO = "alessio.cannino@achubimmobiliare.it";
export const EMAIL_PEC = "direzione@pec.achubimmobiliare.it";
export const INSTAGRAM_URL = "https://www.instagram.com/alessiocannino.realestate";
export const PORTAL_URL = "https://portale.achubimmobiliare.it";
export const EDILIZIA_URL = "https://ediliziacannino.com";
